import React from 'react';

/**
 * Функция для обработки текста с маркерами =bold и bold=
 * Выделяет текст между маркерами жирным шрифтом
 * Возвращает массив элементов для использования в JSX
 *
 * @param {string} text - Исходный текст с маркерами =bold и bold=
 * @returns {Array} - Массив элементов (строки и React элементы <strong>)
 *
 * @example
 * formatBoldText("Обычный текст =bold жирный текст bold= снова обычный")
 * // Вернет: ["Обычный текст ", <strong>жирный текст</strong>, " снова обычный"]
 */
export const formatBoldText = (text) => {
  if (!text || typeof text !== 'string') {
    return [text];
  }

  const result = [];
  let currentIndex = 0;
  const startMarker = '=bold';
  const endMarker = 'bold=';

  while (currentIndex < text.length) {
    // Ищем начало маркера =bold
    const startIndex = text.indexOf(startMarker, currentIndex);

    if (startIndex === -1) {
      // Маркер не найден, добавляем оставшийся текст
      if (currentIndex < text.length) {
        const remainingText = text.substring(currentIndex);
        if (remainingText) {
          result.push(remainingText);
        }
      }
      break;
    }

    // Добавляем текст до маркера
    if (startIndex > currentIndex) {
      const beforeText = text.substring(currentIndex, startIndex);
      if (beforeText) {
        result.push(beforeText);
      }
    }

    // Ищем конец маркера bold=
    const afterStartMarker = startIndex + startMarker.length;
    const endIndex = text.indexOf(endMarker, afterStartMarker);

    if (endIndex === -1) {
      // Закрывающий маркер не найден, добавляем текст как есть
      const remainingText = text.substring(afterStartMarker);
      if (remainingText) {
        result.push(remainingText);
      }
      break;
    }

    // Извлекаем текст между маркерами
    const boldText = text.substring(afterStartMarker, endIndex);
    if (boldText) {
      // Создаем React элемент для жирного текста
      result.push(React.createElement('strong', { key: `bold-${result.length}` }, boldText));
    }

    // Перемещаемся после закрывающего маркера
    currentIndex = endIndex + endMarker.length;
  }

  return result;
};

/**
 * Функция для обработки текста с маркерами =bold и bold=
 * Возвращает строку с HTML тегами <strong>
 *
 * @param {string} text - Исходный текст с маркерами =bold и bold=
 * @returns {string} - Текст с HTML тегами <strong>
 */
export const formatBoldTextHTML = (text) => {
  if (!text || typeof text !== 'string') {
    return text;
  }

  let result = text;
  const startMarker = '=bold';
  const endMarker = 'bold=';

  // Обрабатываем все вхождения маркеров
  while (result.includes(startMarker) && result.includes(endMarker)) {
    const startIndex = result.indexOf(startMarker);
    const afterStartMarker = startIndex + startMarker.length;
    const endIndex = result.indexOf(endMarker, afterStartMarker);

    if (endIndex === -1) {
      break;
    }

    // Извлекаем текст между маркерами
    const boldText = result.substring(afterStartMarker, endIndex);

    // Заменяем маркеры и текст на HTML теги
    result =
      result.substring(0, startIndex) +
      `<strong>${boldText}</strong>` +
      result.substring(endIndex + endMarker.length);
  }

  return result;
};

export default formatBoldText;
